<template>
  <div id="learntWordsBody" class="flexwrap bigShadow currentShowColor"  :style="styleObject"
       v-if="this.appStep === this.states.MENU && this.wordsLearntLoaded"><!-- currentShowColor lightTheme bigRoundAngles-->
    <div id="learntWordsIn">
      <div id="nbWordSeen" class="textShadow smallRoundAngles paddingRound">
        <div v-if="this.currentWordsLearnt.length==0">
          Commence une première session de vocabulaire pour voir tes mots appris apparaitre ici !
        </div>
        <div v-else>
          {{this.currentWordsLearnt.length}} mots déjà vus dans cette saison
        </div>
      </div>

      <transition-group :class="{hidden: gameOn}" name="listfade"  tag="div" style="position: relative" appear>
        <learnt-word v-for="id in idlist1" :key="id" :lemma="wordlist[id].lemma" :review="true" class="listfade-item"> </learnt-word>
      </transition-group>
      <!--<transition-group :class="{hidden: gameOn}" name="listfade" tag="div" style="justify-self: center" appear>
        <learnt-word v-for="id in idlist2" :key="id" :lemma="wordlist[id].lemma" :review="true"  class="listfade-item"></learnt-word>
      </transition-group>-->


      <div id="sessionsMenu" v-if="this.currentWordsLearnt.length!=0">

        <standard-button v-if="currentWordsLearnt.length>0" style="z-index: 2000"
            @click="setSeasonWordsList(eligibleWords)"
            :premium="true"
            :color-class="'plainTheme mediumShadow'"
            :inactive="eligibleWords.length<5">
          Révision
        </standard-button>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
name: "learntWordsSection",
  components: {
    //Game,
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    LearntWord: () => import(/* webpackPrefetch: true */ '@/components/learntWord.vue')
  },
  props: ['numberWords'],
  created: function(){
    // On crée les listes modulaires de mots déjà appris
    this.createLists();
  },

  destroyed() {
    window.clearInterval(this.timeInterval);
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'appStep',
      'states',
      'profile',
      'authenticated',
      'closableCardOpened',
    ]),
    ...mapGetters('show', [
      'currentSeason',
      'currentWordsLearnt',
      'currentShow',
      'seasonRequested',
      'wordsLearntLoaded'
    ]),
    ...mapGetters('game', [
      'gameOn',
    ]),
    wordlist: function (){
        return this.currentWordsLearnt.slice().sort(function(a, b){return b.count-a.count})
    },
    // ne garde que des mots qui pourront être proposés en session review
    eligibleWords: function() {

      return this.currentWordsLearnt.slice().sort(function(a, b){return b.count-a.count}).filter(
          word => word.lemma.user_lemma[0].knowledge_level < 3 && this.timeSinceLearnt(word) > 600
      )
    },
    idlist1: function (){
      if(this.selectedIds.length > this.numberWords){
        return this.selectedIds.slice(0, this.selectedIds.length)
      }
      return this.selectedIds
    },
    styleObject: function () {
      if(this.currentShow.hue != undefined)
      {
        return {
          '--hue': this.currentShow.hue,
        }
      }
      else {
        return {
          '--hue': 330,
        }
      }

    },
  },

  watch: {
    'wordsLearntLoaded': function() {
      if(this.wordsLearntLoaded) {
        // on évite que les mots avec un count nul soient exclus
        this.currentWordsLearnt.forEach((element) => {
          element.count += 0.1;
        })
        this.createLists();
      }

    },
  },

  methods: {
    ...mapActions('global', [
      'set_appStep'
    ]),
  ...mapActions('session', [
      'set_sessionWordsList',
      'set_sessionType'
  ]),
    ...mapActions('game', [
      'set_gameOn',
      'set_gameWordsList',
      'set_gameWordsListLoaded',
      'set_gameOrigin'
    ]),
  timeSinceLearnt: function(word) {
    let last_studied = new Date(word.lemma.user_lemma[0].last_studied)
    return Math.abs(new Date() - last_studied)/60000
  },
  createLists: function() {
    let i;
    this.selectedIds = []
    for (i = 0; i < Math.min(this.numberWords, this.wordlist.length); i++) {
      this.selectedIds.push(this.pickWord())
    }
    if (this.wordlist.length > this.selectedIds.length) {
      this.timeInterval = window.setInterval(this.replaceWord, 3000)
    }
  },
    totalWeightLeft: function (){
      let i = 0;
      let totalWeight = 0
      for(i=0; i < this.wordlist.length; i++){
        if(!this.selectedIds.includes(i)){
          totalWeight+= this.wordlist[i].count+0.1
        }
      }
      return totalWeight
    },
    getRandomInt: function(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    replaceWord: function () {
      let newId = this.pickWord();
      let positionToRemove = this.getRandomInt(this.selectedIds.length)
      /*while(positionToRemove === this.lastRemoved){
        positionToRemove = this.getRandomInt(this.selectedIds.length)
      }*/
      this.lastRemoved = positionToRemove
      this.selectedIds[positionToRemove] = newId
      this.selectedIds.push()
    },
    pickWord: function () { //////////Choisi un mot au
      let tot = this.totalWeightLeft()
      let randomNum = Math.random()*tot;
      let i = 0;
      let currentWeight = 0
      for(i=0; i < this.wordlist.length; i++){
        if(!this.selectedIds.includes(i)){
          currentWeight+= this.wordlist[i].count+0.1
          if(currentWeight>randomNum){
            break
          }
        }
      }
      return i
    },

    setSeasonWordsList: function(wordsList) {
      let randomArray = []
      let startingArray = wordsList.slice();
      //Filtrer les mots or et les mots vus il y a moins de 24h
      let nbWords = 10;
      if(wordsList.length <10) {
        nbWords = wordsList.length
      }

      // On applique 12 fois l'algorithme qui choisit un mot aléatoirement pondéré
      for(let i=0; i<nbWords; i++) {
        // First, we loop the main dataset to count up the total weight.
        // We're starting the counter at one because the upper boundary
        // of Math.random() is exclusive.
        let total = 0;
        let find = false;

        for (let j = 0; j < startingArray.length; j++) {
          total += startingArray[j].count;
        }

        // Total in hand, we can now pick a random value akin to our
        // random index from before.
        const threshold = Math.random() * total;

        // Now we just need to loop through the main data one more time
        // until we discover which value would live within this
        // particular threshold. We need to keep a running count of
        // weights as we go, so let's just reuse the "total" variable
        // since it was already declared.
        total = 0;
        for (let j = 0; j < startingArray.length-1; j++) {
          if(!find) {
            // Add the weight to our running total.
            total += startingArray[j].count;

            // If this value falls within the threshold, we're done!
            if (total >= threshold) {
              randomArray.push(startingArray[j]);
              startingArray.splice(j,1)
              find = true;
            }
          }

        }

        if(!find) {
          // Wouldn't you know it, we needed the very last entry!
          randomArray.push(startingArray[startingArray.length - 1]);
          startingArray.splice(startingArray.length - 1, 1)
          find = true;
        }
      }

      this.set_sessionType('season')
      this.set_sessionWordsList(randomArray);
      this.set_appStep(this.states.ONGOING_SESSION)

      /*if(this.profile.datas.is_premium) {
        let randomArray = []
        let startingArray = wordsList.slice();
        //Filtrer les mots or et les mots vus il y a moins de 24h
        let nbWords = 10;
        if(wordsList.length <10) {
          nbWords = wordsList.length
        }

        // On applique 12 fois l'algorithme qui choisit un mot aléatoirement pondéré
        for(let i=0; i<nbWords; i++) {
          // First, we loop the main dataset to count up the total weight.
          // We're starting the counter at one because the upper boundary
          // of Math.random() is exclusive.
          let total = 0;
          let find = false;

          for (let j = 0; j < startingArray.length; j++) {
            total += startingArray[j].count;
          }

          // Total in hand, we can now pick a random value akin to our
          // random index from before.
          const threshold = Math.random() * total;

          // Now we just need to loop through the main data one more time
          // until we discover which value would live within this
          // particular threshold. We need to keep a running count of
          // weights as we go, so let's just reuse the "total" variable
          // since it was already declared.
          total = 0;
          for (let j = 0; j < startingArray.length-1; j++) {
            if(!find) {
              // Add the weight to our running total.
              total += startingArray[j].count;

              // If this value falls within the threshold, we're done!
              if (total >= threshold) {
                randomArray.push(startingArray[j]);
                startingArray.splice(j,1)
                find = true;
              }
            }

          }

          if(!find) {
            // Wouldn't you know it, we needed the very last entry!
            randomArray.push(startingArray[startingArray.length - 1]);
            startingArray.splice(startingArray.length - 1, 1)
            find = true;
          }
        }

        this.set_sessionType('season')
        this.set_sessionWordsList(randomArray);
        this.set_appStep(this.states.ONGOING_SESSION)
      }

      else {
        this.$router.push({name: 'premium'})
      }*/
    },

    setGame(wordsList) {
      let tempArray = [];
      wordsList.forEach((element) => {
        tempArray.push(element.lemma)
      })
      this.set_gameWordsList(tempArray);
      this.set_gameWordsListLoaded(true);
      this.set_gameOn(true);
      this.set_gameOrigin("season")
    }
  },
  data() {
    return {
      selectedIds: [],
      lastRemoved: 0,
      screenWidth: window.screen.width,
      timeInterval: false,
    }
  }
}
</script>

<style scoped>
  #learntWordsBody{
    justify-content: center;
    z-index:0;
    min-height:7vw;
    max-height:7vw;
    height:7vw;
    max-width: 54vw;
    width: fit-content;
    min-width: 54vw;

    background-color: hsla(var(--hue), 80%, 25%, 0.45);
    border-radius: 0 0 2vw 2vw;
    margin-top: -2vw;
    padding-top: 2vw;
    padding-bottom: 1vw;


    backdrop-filter: blur(0.25vw);
    -webkit-backdrop-filter: blur(0.25vw);
  }
  #learntWordsIn{
    width: 100%;
    justify-items: center;
    justify-content: center;
    align-items: flex-start;
    margin-top: 1vw;
    display: grid;
    grid-gap: 0.5vw;
    grid-template-rows: auto auto 1fr auto;
  }

  #sessionsMenu {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  #nbWordSeen{
    /*background-color: #22222255;*/

  }

  .listfade-item {
    transition: all 1s;
    display: inline-block;

  }
  .listfade-enter, .listfade-leave-to {
    opacity: 0;
    /*transform: translateY(-10vw);*/
  }
  .listfade-leave-active {
    position: absolute;
  }

  .fade-enter-active {
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
    -ms-transition: all 1.5s;
  }

  .fade-enter /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  /*/////////////////////////// Theme ///////////////////////////////////////*/
  .currentShowColor {
    --lightColor: hsla(var(--hue), 100%, 95%, 1);
    --lightplainColor: hsla(var(--hue), 100%, 87%, 1);
    --darkColor: hsla(var(--hue), 100%, 5%, 1);
    --plainColor: hsla(var(--hue), 100%, 20%, 1);
    --lightGrey: hsla(var(--hue), 10%, 80%, 1);
  }

  @media screen and (max-device-width: 767px) {
    #learntWordsBody{
      max-height:90%;
      min-height:50%;
      height:min-content;
      max-width: calc(100% - 5vw);
      width: calc(100% - 5vw);
      min-width: calc(100% - 5vw);
      border-radius: 0 0 8vw 8vw;
      margin-top: -8vw;
      padding-top: 8vw;
      padding-bottom: 4vw;
      /*background-color: #52BBF9;*/
      /*margin-top: 1vw;
      padding-bottom: 1vw;*/
    }
    #nbWordSeen{
      font-size: 110%;

    }
  }
</style>